import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsLeaderIDSmartEntryPointsEnabled = () => boolean;
export const useIsLeaderIDSmartEntryPointsEnabled: UseIsLeaderIDSmartEntryPointsEnabled = () =>
  useExperimentTreatmentWithoutReporting(Experiment.LeaderIDSmartEntryPoints) === true;
